// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__fC3xg","loaderOuter":"PageOverlayLoader_loaderOuter__1Rr3X"};